import { render, staticRenderFns } from "./ProjectStatusActions.vue?vue&type=template&id=422f77f4&scoped=true"
import script from "./ProjectStatusActions.vue?vue&type=script&lang=js"
export * from "./ProjectStatusActions.vue?vue&type=script&lang=js"
import style0 from "./ProjectStatusActions.vue?vue&type=style&index=0&id=422f77f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422f77f4",
  null
  
)

export default component.exports